const container = {
  backgroundColor: 'common.white',
  border: '1px solid',
  borderColor: 'grey.200',
  padding: 2,
}

export default { container }
